// extracted by mini-css-extract-plugin
export default {"prizePool":"LotteryPrize_prizePool__totN2","openPopUp":"LotteryPrize_openPopUp__czG02"};